module.exports = __webpack_public_path__ + "img/logo.6c8810f4.svg";